import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "panding",
  "use": "panding-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"panding\"><path d=\"M12 4a8 8 0 110 16 8 8 0 010-16zm0 1.067a6.933 6.933 0 100 13.866 6.933 6.933 0 000-13.866z\" /><circle cx=\"12\" cy=\"12\" r=\"1\" /><circle cx=\"16\" cy=\"12\" r=\"1\" /><circle cx=\"8\" cy=\"12\" r=\"1\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol